/**
 * all ado member eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';
import { AuthLoginRequest } from '../model/authLoginRequest';
import { AuthLoginResponse } from '../model/authLoginResponse';
import { ExchangeAvailabilityRequest } from '../model/exchangeAvailabilityRequest';
import { ExchangeAvailabilityResponse } from '../model/exchangeAvailabilityResponse';
import { GetMemberInformationResponse } from '../model/getMemberInformationResponse';
import { GetRequiredMilesRequest } from '../model/getRequiredMilesRequest';
import { GetRequiredMilesResponse } from '../model/getRequiredMilesResponse';
import { MemberAvailabilityRequest } from '../model/memberAvailabilityRequest';
import { MemberAvailabilityResponse } from '../model/memberAvailabilityResponse';
import { ReservationAvailabilityRequest } from '../model/reservationAvailabilityRequest';
import { ReservationAvailabilityResponse } from '../model/reservationAvailabilityResponse';
import { Type } from '../model/type';
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root',
})
export class MemberApiService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * # 1. 概要 リクエストパラメータをもとにログイン認証用パラメータをsAPIに渡し、ログイン認証結果をレスポンスとして受け取る。  # 2. 処理内容   1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、&lt;br/&gt;     エラーハンドリング(API)(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。    1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにて、アクセストークンの有効性確認およびTTL延長を行う。&lt;br/&gt;     有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。    1. 以下の提携IF定義書に従い、リクエストパラメータの値チェックを行う。&lt;br/&gt;     エラーが発生している場合、ステータスコード400(Bad Request)でエラー情報を返して、本処理を中止とする。&lt;br/&gt;     ※文字種、桁数チェックは1.のMulesoftが行う入力チェックで行う。&lt;br/&gt;     ■提携IF定義書&lt;br/&gt;      &amp;emsp;ファイル名：【他システムIF】提携IF定義書(全社サマリ)_03_FFP.xlsx&lt;br/&gt;      &amp;emsp;シート名：ログイン認証    1. 以下の内容でiFly_ログイン認証のsAPIを呼び出し、ペイロードされたJSON形式のログイン認証結果を取得する。&lt;br/&gt;     HTTPメソッド：POST&lt;br/&gt;     URL：/authenticate-customer-service&lt;br/&gt;     パラメータ：提携IF定義書のリクエスト項目を基にJSON形式でリクエストを作成し、sAPIのリクエストボディに設定    1. ログイン認証結果について、エラーコードが返却された場合、ステータスコード400でエラー情報を返して、本処理を中止とする。    1. パスワード再認証(reauthorizationPassward&#x3D;\&quot;true\&quot;)かつ、正常終了の場合、生成したログイン認証結果とHTTPステータスコード200を返却し、処理を終了する。    1. パスワード再認証でない(reauthorizationPassward&#x3D;\&quot;false\&quot;)場合、会員詳細情報照会pAPIを呼び出す。&lt;br/&gt;     エラーが発生した場合、ステータスコード400でエラー情報を返して、本処理を中止とする。&lt;br/&gt;     HTTPメソッド：POST&lt;br/&gt;     URL：/get-member-information&lt;br/&gt;     パラメータ：以下をpAPIのリクエストボディに設定     | 論理名 | 設定値 |     | :----- | :----- |     | 会員番号 | リクエストパラメータから会員番号を設定する |     | 会員番号 | transitionSource&#x3D;\&quot;A\&quot; |    1. 正常終了の場合、生成したログイン認証結果・会員情報とHTTPステータスコード200を返却し、処理を終了する。
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public authLoginPost(
    generated?: AuthLoginRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<AuthLoginResponse>;
  public authLoginPost(
    generated?: AuthLoginRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<AuthLoginResponse>>;
  public authLoginPost(
    generated?: AuthLoginRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<AuthLoginResponse>>;
  public authLoginPost(
    generated?: AuthLoginRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/auth-login`;
    return this.httpClient.request<AuthLoginResponse>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要 DynamoDBに接続し、会員情報をレスポンスとして受け取る。  # 2. 処理内容   1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてアクセストークンの有効性確認およびTTL延長を行う。&lt;br/&gt;     有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。　    1. 認可検証APIのレスポンスのuuidをキーとして、DynamoDBのパーソナライズ情報を取得する。    1. ユーザ共通情報のログインステータスがリアルログイン以外の場合、ステータスコード400(Bad request)でエラー情報を返して、本処理を中止とする。    1. パーソナライズ情報のiFly会員情報をレスポンスとし、ステータスコード200(正常)を返却する。
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMemberInformationPost(
    generated?: object,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<GetMemberInformationResponse>;
  public getMemberInformationPost(
    generated?: object,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<GetMemberInformationResponse>>;
  public getMemberInformationPost(
    generated?: object,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<GetMemberInformationResponse>>;
  public getMemberInformationPost(
    generated?: object,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/get-member-information`;
    return this.httpClient.request<GetMemberInformationResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要 リクエストパラメータをもとに会員情報取得用パラメータをsAPIに渡し、会員情報をレスポンスとして受け取る。  # 2. 処理内容   1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、&lt;br/&gt;     エラーハンドリング(API)(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。    1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにて、アクセストークンの有効性確認およびTTL延長を行う。&lt;br/&gt;     有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。    1. 以下の処理をリクエストのPAX数分繰り返す。     1. 会員情報取得pAPIを呼び出す。エラーが発生した場合、memberAvailability&#x3D;\&quot;C\&quot;で返却する。&lt;br/&gt;     HTTPメソッド：POST&lt;br/&gt;     URL：/get-member-information&lt;br/&gt;     パラメータ：以下をpAPIのリクエストボディに設定     | 論理名 | 設定値 |     | :----- | :----- |     | 会員番号 | リクエストパラメータから会員番号を設定する |     | 会員番号 | transitionSource&#x3D;\&quot;C\&quot; |     1. リクエスト項目とレスポンス項目を参照し、それぞれの姓・名・生年月日が一致するかのチェックを行う。&lt;br/&gt;     どれか１つでも一致しない場合、memberAvailability&#x3D;\&quot;C\&quot;で返却する。    1. 正常終了の場合、生成した会員情報・証憑情報とHTTPステータスコード200を返却し、処理を終了する。
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public memberAvailabilityPost(
    generated?: MemberAvailabilityRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<MemberAvailabilityResponse>;
  public memberAvailabilityPost(
    generated?: MemberAvailabilityRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<MemberAvailabilityResponse>>;
  public memberAvailabilityPost(
    generated?: MemberAvailabilityRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<MemberAvailabilityResponse>>;
  public memberAvailabilityPost(
    generated?: MemberAvailabilityRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/member-availability`;
    return this.httpClient.request<MemberAvailabilityResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要   リクエストパラメータを基に会員詳細情報照会eAPI、必要マイル数取得eAPIを実行し、&lt;br/&gt;   各eAPIから取得した情報をもとに判断した交換発行可否結果、および、画面の表示情報をレスポンスとして受け取る。  # 2. 処理内容   1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、&lt;br/&gt;     エラーハンドリング(API)(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。    1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてアクセストークンの有効性確認およびTTL延長を行う。&lt;br/&gt;     有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。    1. 呼び出し元より渡されたアクセストークンを復号し、トークン内に含まれるuuidを基に、ALLDB(Tx)からログイン中の会員情報を取得する。&lt;br/&gt;     会員情報を取得できなかった場合、HTTPステータスコード400(Bad Request)でエラー情報を返して、本処理を中止とする。    1. 会員情報取得pAPIを呼び出し、ペイロードされたJSON形式の保有マイル数を取得する。&lt;br/&gt;     取得に失敗した場合は本処理を中止し、400エラーを返却する。&lt;br/&gt;     HTTPメソッド：POST&lt;br/&gt;     URL：/get-member-information&lt;br/&gt;     パラメータ：提携IF定義書のリクエスト項目を基にJSON形式でリクエストを作成し、固定値以外の値としては以下をpAPIのリクエストボディに設定       | 論理名 | 設定値 |       | :----- | :----- |       | 会員番号 | 3で取得した会員情報から会員番号を設定する |    1. 呼び出し元より渡された予約番号に基づき、PNR情報取得APIから証明書番号、搭乗者種別毎の人数、一部搭乗済判定、バウンド情報を取得する。&lt;br/&gt;     取得できなかった場合、HTTPステータスコード400(Bad Request)でエラー情報を返却して、本処理を中止とする。&lt;br/&gt;     HTTPメソッド：POST&lt;br/&gt;     URL：/orders/get-order&lt;br/&gt;     パラメータ：以下をeAPIのリクエストボディに設定       | 論理名 | 設定値 |       | :----- | :----- |       | 予約番号 | リクエストパラメータから予約番号を設定する |    1. PNR情報取得APIにて取得した交換発行前PNR(以下、PNR情報)が発券後予約変更利用不可と判定された場合(PNR情報.data.orderEligibilities.change.isEligible&#x3D;false)、&lt;br/&gt;     HTTPステータスコード400(Bad Request)でエラー情報を返却し、本処理を中止とする。    1. PNR情報取得APIより受け取った証明書番号を基に証明書詳細情報照会sAPIを呼び出し、減算マイル数、有効期限内マイル数(以下、払戻可能マイル数とする)、有効期限切れマイル数を取得する。&lt;br/&gt;     取得できなかった場合、HTTPステータスコード400(Bad Request)でエラー情報を返却して、本処理を中止とする。&lt;br/&gt;     HTTPメソッド：POST&lt;br/&gt;     URL：/retrieve-certificate-details-service&lt;br/&gt;     パラメータ：以下をsAPIのリクエストボディに設定       | 論理名 | 設定値 |       | :----- | :----- |       | 証明書番号 | 5で取得したPNR情報から証明書番号を設定する |            1. 払戻完了日に日付が返却された場合(証明書番号が無効)、HTTPステータスコード400(Bad Request)でエラー情報を返却し、本処理を中止とする。    1. リクエストパラメータより受け取った交換発行後のバウンドIDを基にDxAPIを呼び出し、SEG毎の出発空港・到着空港・出発日時を取得する。&lt;br/&gt;     取得できなかった場合、HTTPステータスコード400(Bad Request)でエラー情報を返却して、本処理を中止とする。&lt;br/&gt;     HTTPメソッド：POST&lt;br/&gt;     URL：/purchase/orders/{orderId}/order-changes&lt;br/&gt;     パラメータ：以下をeAPIのリクエストボディに設定       | 論理名 | 設定値 |       | :----- | :----- |       | 予約番号 | リクエストパラメータから予約番号を設定する |       | バウンドID | リクエストパラメータからバウンドIDを設定する |    1. PNR情報から取得した一部搭乗済判定がtrueの場合、必要マイル数取得eAPIを呼び出し、ペイロードされたJSON形式の交換発行前の復路に必要な総マイル数(以下、払戻指定マイル数とする)を取得する。&lt;br/&gt;     取得に失敗した場合は本処理を中止し、400エラーを返却する。&lt;br/&gt;     HTTPメソッド：POST&lt;br/&gt;     URL：/orders/get-required-miles&lt;br/&gt;     パラメータ：提携IF定義書のリクエスト項目を基にJSON形式でリクエストを作成し、固定値以外の値としては以下をeAPIのリクエストボディに設定       | 論理名 | 設定値 |       | :----- | :----- |       | 復路出発日(dd-MMM-yyyy) | 5で取得したバウンド情報からdepartureDateを設定する |       | 復路出発空港 | 5で取得したバウンド情報からoriginLocationCodeを設定する |       | 復路到着空港 | 5で取得したバウンド情報からdestinationLocationCodeを設定する |       | 搭乗者数 | 5で取得した搭乗者数を設定する |    1. 必要マイル数取得eAPIを呼び出し、ペイロードされたJSON形式の交換発行後に必要な総マイル数(以下、必要マイル数とする)を取得する。&lt;br/&gt;     取得に失敗した場合は本処理を中止し、400エラーを返却する。&lt;br/&gt;     HTTPメソッド：POST&lt;br/&gt;     URL：/orders/get-required-miles&lt;br/&gt;     パラメータ：提携IF定義書のリクエスト項目を基にJSON形式でリクエストを作成し、固定値以外の値としては以下をeAPIのリクエストボディに設定       | 論理名 | 設定値 |       | :----- | :----- |       | 往路出発日(dd-MMM-yyyy) | 8で取得したバウンド情報から1SEG目のdepartureDateを設定する |       | 往路出発空港 | 8で取得したバウンド情報から1SEG目のoriginLocationCodeを設定する |       | 往路到着空港 | 8で取得したバウンド情報から1SEG目のdestinationLocationCodeを設定する |       | 復路出発日(dd-MMM-yyyy) | 8で取得したバウンド情報から2SEG目のdepartureDateを設定する |       | 復路出発空港(復路出発日が存在する場合、必須) | 8で取得したバウンド情報から2SEG目のoriginLocationCodeを設定する |       | 復路到着空港(復路出発日が存在する場合、必須) | 8で取得したバウンド情報から2SEG目のdestinationLocationCodeを設定する |       | 搭乗者数 | 5で取得した搭乗者数を設定する |    1. 5、7、9、10で取得した会員情報やマイル数をもとに、PNRの交換発行可否を判断する。&lt;br/&gt;     PNRが以下いずれかに該当する場合は交換発行可能(交換発行可否フラグ＝true)とし、それ以外は交換発行不可(交換発行可否フラグ＝false)とする。     1. PNR情報から取得した一部搭乗済判定がfalseの場合、(マイル残高＋払戻可能マイル数)ー必要マイル数≧0     1. PNR情報から取得した一部搭乗済判定がtrue、かつ、払戻可能マイル数≧払戻指定マイル数の場合、(マイル残高＋払戻指定マイル数)ー必要マイル数≧0     1. PNR情報から取得した一部搭乗済判定がtrue、かつ、払戻可能マイル数＜払戻指定マイル数の場合、(マイル残高＋払戻可能マイル数)ー必要マイル数≧0    1. 正常終了の場合、交換発行不可フラグとHTTPステータスコード200を返却し、処理を終了する。  # 3. データ更新内容   なし  # 4. 特記事項   なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public ordersExchangeAvailabilityPost(
    generated?: ExchangeAvailabilityRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<ExchangeAvailabilityResponse>;
  public ordersExchangeAvailabilityPost(
    generated?: ExchangeAvailabilityRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<ExchangeAvailabilityResponse>>;
  public ordersExchangeAvailabilityPost(
    generated?: ExchangeAvailabilityRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<ExchangeAvailabilityResponse>>;
  public ordersExchangeAvailabilityPost(
    generated?: ExchangeAvailabilityRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/orders/exchange-availability`;
    return this.httpClient.request<ExchangeAvailabilityResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * # 1. 概要   呼び出し元から連携されたリクエストパラメータより必要マイル数取得IFを実行し、必要マイル数照会情報をレスポンスとして受け取る。  # 2. 処理内容   1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、&lt;br/&gt;     エラーハンドリング(API)(G01-010)を利用してMulesoftが生成したエラー情報を解析し、ステータスコード400(Bad request)でエラー情報を返却する。    1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてアクセストークンの有効性確認およびTTL延長を行う。&lt;br/&gt;     有効でない場合、ステータスコード401(Unauthorized)でエラー情報を返して、本処理を中止とする。    1. パーソナライズ情報取得を行い、会員番号を取得する。    1. 以下の提携IF定義書に従い、リクエストパラメータの必須チェックを行う。     エラーが発生している場合、ステータスコード400(Bad Request)でエラー情報を返して、本処理を中止とする。&lt;br/&gt;     ※文字種、桁数チェックは1.のMulesoftが行う入力チェックで行う。&lt;br/&gt;     ファイル名：【他システムIF】提携IF定義書(全社サマリ)_03_FFP.xlsx&lt;br/&gt;     シート名：必要マイル数照会    1. 復路搭乗日に値がある場合、《往復フラグ》をtrue、復路搭乗日がnullまたは空文字の場合falseとする。    1. 必要マイル数取得sAPIリクエストを行う。（1SEG・1PAXずつリクエストを行う必要がある）     1. 以下の内容で片道 または 往路の必要マイル数照会のsAPIを呼び出し、ペイロードされたJSON形式の必要マイル数照会情報を取得する。&lt;br/&gt;       HTTPメソッド：POST&lt;br/&gt;       URL：/retrieve-rewards-with-pricing-detail-service&lt;br/&gt;       パラメータ：提携IF定義書のリクエスト項目を基にJSON形式でリクエストを作成し、sAPIのリクエストボディに設定         | 論理名 | 呼び出し元から渡されたパラメータから取得する設定値 |         | :------------- | :------------- |         | パーソナライズ情報.会員番号 | 会員番号 |         | マイル照会情報.出発空港 | 往路出発空港 |         | マイル照会情報.到着空港 | 往路到着空港 |         | マイル照会情報.搭乗日 | 往路出発日 |         | マイル照会情報.動的属性情報.属性コード0番目 | ITNTPを設定する |         | マイル照会情報.動的属性情報.属性値0番目 | 《往復フラグ》がtrueの場合、R / falseの場合、O |     1. 必要マイル数情報.特典情報リスト0番目.マイル設定詳細情報.必要マイル数（《往路必要マイル数》）について、IF定義書に従い、型、桁数のチェックを行う。&lt;br/&gt;         エラーが発生している場合、ステータスコード400でエラー情報を返して、本処理を中止とする。&lt;br/&gt;         ※1SEG・1PAXずつ必要マイル数を取得するため、特典情報リストは1件のみ返却される想定。&lt;br/&gt;    1. 《往復フラグ》がtrueの場合、復路用の必要マイル数取得sAPIリクエストを行う。     1. 5-1同様に復路の必要マイル数照会のsAPIを呼び出し、ペイロードされたJSON形式の必要マイル数照会情報を取得する。&lt;br/&gt;         ※ パラメータ以外は5-1と共通のため、省略&lt;br/&gt;         パラメータ：提携IF定義書のリクエスト項目を基にJSON形式でリクエストを作成し、sAPIのリクエストボディに設定           | 論理名 | 呼び出し元から渡されたパラメータから取得する設定値 |           | :------------- | :------------- |           | パーソナライズ情報.会員番号 | 会員番号 |           | マイル照会情報.出発空港 | 往路出発空港 |           | マイル照会情報.到着空港 | 往路到着空港 |           | マイル照会情報.搭乗日 | 往路出発日 |           | マイル照会情報.動的属性情報.属性コード0番目 | ITNTPを設定する |           | マイル照会情報.動的属性情報.属性値0番目 | R |     1. 必要マイル数情報.特典情報リスト0番目.マイル設定詳細情報.必要マイル数（《復路必要マイル数》）について、IF定義書に従い、型、桁数のチェックを行う。&lt;br/&gt;         エラーが発生している場合、ステータスコード400でエラー情報を返して、本処理を中止とする。    1. 《往復フラグ》がtrueの場合、《往路必要マイル数》と《復路必要マイル数》の合計を、falseの場合は《往路必要マイル数》を《必要マイル数》とする。    1.《必要マイル数》に搭乗者数を乗じ、《必要総マイル数》を求める。    1. 正常終了の場合、HTTPステータスコード200 OKと必要マイル数照会結果を返却し、処理を終了する。  # 3. データ更新内容   なし  # 4. 特記事項   なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public ordersGetRequiredMilesPost(
    generated?: GetRequiredMilesRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<GetRequiredMilesResponse>;
  public ordersGetRequiredMilesPost(
    generated?: GetRequiredMilesRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<GetRequiredMilesResponse>>;
  public ordersGetRequiredMilesPost(
    generated?: GetRequiredMilesRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<GetRequiredMilesResponse>>;
  public ordersGetRequiredMilesPost(
    generated?: GetRequiredMilesRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;
    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/orders/get-required-miles`;
    return this.httpClient.request<GetRequiredMilesResponse>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generated,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * # 1. 概要   リクエストパラメータをもとに会員情報取得pAPI、必要マイル数取得eAPIを実行し、&lt;br/&gt;   各APIから取得した情報をもとに判断した予約可否結果、および、画面の表示情報をレスポンスとして受け取る。  # 2. 処理内容   1. Mulesoftが行う入力チェック(各項目の型定義などに応じたチェック)にてエラーが発生している場合、&lt;br/&gt;     共通部品「エラーハンドリング」(G01-010)を利用してMulesoftが生成したエラー情報を解析し、**HTTPステータスコード:400**でエラー情報を返却して、本処理を中止とする。    1. 呼び出し元より渡されたアクセストークンについて、認可検証APIにてアクセストークンの有効性確認およびTTL延長を行う。&lt;br/&gt;     有効でない場合、**HTTPステータスコード:401**でエラー情報を返却して、本処理を中止とする。    1. 呼び出し元より渡されたアクセストークンを復号し、トークン内に含まれるuuidを基に、ALLDB(Tx)からログイン中の会員情報を取得する。&lt;br/&gt;     会員情報を取得できなかった場合、**HTTPステータスコード:401**でエラー情報を返却して、本処理を中止とする。    1. リクエストパラメータより受け取ったカートIDを基にDxAPIを呼び出し、カートのdictionaries・airOffersよりSEG毎の出発空港コード・到着空港コード・出発年月日、travelersの搭乗者種別毎の人数を取得する。&lt;br/&gt;     パラメータが取得できなかった場合、不正なカートIDが指定されたとみなし、**HTTPステータスコード:400**でエラー情報を返却して、本処理を中止とする。&lt;br/&gt;     HTTPメソッド：GET&lt;br/&gt;     URL：/shopping/carts/{cartId}&lt;br/&gt;     パラメータ：以下をeAPIのリクエストボディに設定       |論理名|設定値|       |:---|:---|       |カートID|リクエストパラメータからカートIDを設定する|    1. カート情報から取得した搭乗者種別毎の人数をもとに、INF以外の搭乗者数を取得する。&lt;br/&gt;     INF以外の搭乗者数が0の場合、**HTTPステータスコード:400**でエラー情報を返却して、本処理を中止とする。    1. 会員情報取得pAPIを呼び出し、ペイロードされたJSON形式の保有マイル数(マイル残高)を取得する。&lt;br/&gt;     取得に失敗した場合、**HTTPステータスコード:400**でエラー情報を返却して、本処理を中止とする。&lt;br/&gt;     HTTPメソッド：POST&lt;br/&gt;     URL：/get-member-information&lt;br/&gt;     パラメータ：以下をpAPIのリクエストボディに設定       |論理名|設定値|       |:---|:---|       |会員番号|取得した会員情報から会員番号を設定する|    1. 必要マイル数取得eAPIを呼び出し、ペイロードされたJSON形式の新規予約に必要なマイル数情報を取得する。&lt;br/&gt;     取得に失敗した場合、**HTTPステータスコード:400**でエラー情報を返却して、本処理を中止とする。&lt;br/&gt;     HTTPメソッド：POST&lt;br/&gt;     URL：/orders/get-required-miles&lt;br/&gt;     パラメータ：以下をeAPIのリクエストボディに設定       |論理名|設定値|       |:---|:---|       |往路出発日(dd-MMM-yyyy)|取得したカート情報のdictionariesから1SEG目のdeparture.dateTimeを設定する|       |往路出発空港|取得したカート情報のairOffersから1SEG目のoriginLocationCodeを設定する|       |往路到着空港|取得したカート情報のairOffersから1SEG目のdestinationLocationCodeを設定する|       |復路出発日(dd-MMM-yyyy)|取得したカート情報のdictionariesから2SEG目のdeparture.dateTimeを設定する|       |復路出発空港（復路出発日が存在する場合、必須）|取得したカート情報のairOffersから2SEG目のoriginLocationCodeを設定する|       |復路到着空港（復路出発日が存在する場合、必須）|取得したカート情報のairOffersから2SEG目のdestinationLocationCodeを設定する|       |搭乗者数|算出したINF以外の搭乗者数を設定する|    1. 取得した「マイル残高」や「必要総マイル数」をもとに、PNRの予約可否を判断する。&lt;br/&gt;     PNRが以下に該当する場合は新規予約可能(予約可否フラグ＝true)とし、それ以外は新規予約不可(予約可否フラグ＝false)とする。     1. マイル残高 - 必要総マイル数 ≧ 0    1. 正常終了の場合、予約可否情報と画面表示情報と**HTTPステータスコード:200**を返却し、本処理を終了する。  # 3. データ更新内容   なし  # 4. 特記事項   なし
   * @param generated
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public ordersReservationAvailabilityPost(
    generated?: ReservationAvailabilityRequest,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<ReservationAvailabilityResponse>;
  public ordersReservationAvailabilityPost(
    generated?: ReservationAvailabilityRequest,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpResponse<ReservationAvailabilityResponse>>;
  public ordersReservationAvailabilityPost(
    generated?: ReservationAvailabilityRequest,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<HttpEvent<ReservationAvailabilityResponse>>;
  public ordersReservationAvailabilityPost(
    generated?: ReservationAvailabilityRequest,
    observe: any = 'body',
    reportProgress = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    const localVarPath = `/orders/reservation-availability`;
    return this.httpClient.request<ReservationAvailabilityResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: generated,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
